import React from 'react';

const Japan = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 900 600" {...props}>
      <title>Japanese Flag</title>
      <path d="M0 0h900v600H0z" fill="#fff" />
      <circle cx="450" cy="300" fill="#bc002d" r="180" />
    </svg>
  );
};

export default Japan;
